export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_SEARCH_DEBOUNCE_MS = 300;
export const DEFAULT_ID_PARAM = 'id';

export const DATA_SCREEN_MESSAGE_KEYS = {
  save: 'actions.save',
  delete: 'actions.delete',
  emptyTitle: 'emptyState.title',
  emptyDescription: 'emptyState.description',
} as const;
